import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import OrderReturnsList from './OrderReturnsList';
import {OrderReturnShow} from './OrderReturnShow';

export default {
    icon: AssignmentReturnIcon,
    list: OrderReturnsList,
    show: OrderReturnShow
};
